<script setup>import { ref as _ref, computed as _computed } from 'vue';

  import ServingSizeCalculator from "./serving-size-calculator.vue";

  let perPackageWeight = _ref(null);
  let unit = _ref("g");

  const displayUnit = _computed(() => unit.value);
  const numericWeight = _computed(() => {
    const n = Number(perPackageWeight.value);
    return n > 0 ? n : null;
  });
</script>

<template>
  <div>
    <div class="columns mb-0">
      <div class="column is-4">
        <label class="label" for="package-weight">Per package weight</label>
        <div class="control">
          <input
            id="package-weight"
            v-model="perPackageWeight"
            type="number"
            class="input"
            step="any"
            min="0.01"
            placeholder="e.g. 340"
          />
        </div>
      </div>
      <div class="column is-4">
        <label class="label" for="package-unit">Unit</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select id="package-unit" v-model="unit">
              <option value="g">grams (g)</option>
              <option value="mL">milliliters (mL)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <ServingSizeCalculator
      :per-package-weight="numericWeight"
      :display-unit="displayUnit"
      :public="true"
    />
  </div>
</template>
